export const canInsertStatement = () => () => {
    return function (nodes, statement) {
        const ns = [...nodes].filter(
            node => this.actions.canInsertStatement(node, statement)
        )

        if (1 === ns.length) {
            return ns
        }
        else {
            return []
        }
    }
}

export const insertStatement = () => () => {
    return async function (nodes, statement) {
        await this.execute(
            () => this.actions.insertStatement(nodes, statement)
        )
    }
}
